import React, { useEffect, useState } from 'react'
import { Alert, Snackbar, Box } from '@mui/material'

import type { AlertColor } from '@mui/material/Alert'
import { Outlet, useNavigate } from 'react-router-dom'
import { useSidebarContext } from '../contexts/Old_SidebarContext'

import baseUrl from '../config/baseUrl'
import Header from '../components/Header'
import Footer from '../components/Footer'

// interface SType {
//   isLoggedIn: boolean;
//   setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
//   // Add other properties as needed
// }

function HomeLayout() {
  const navigate = useNavigate()
  const { isLoggedIn, setIsLoggedIn, uniqueString, deleteUniqueString } = useSidebarContext()
  const [lastUrl, setLastUrl] = useState('')
  // Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor | undefined>(undefined)

  const token = sessionStorage.getItem('token')

  useEffect(() => {
    setLastUrl(sessionStorage?.getItem('urlAtLeaving') ?? '')

    const fetchIpAndStore = async () => {
      try {
        // Fetch the IP address
        const ipResponse = await fetch('https://api.ipify.org?format=json')
        const ipData = await ipResponse.json()
        // console.log('ipData', ipData)
        const ip = ipData?.ip

        // Send the IP address to the backend
        await fetch(`${baseUrl}/api/admin/storeIpAddress`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ipAddress: ip }),
        })
      } catch (error) {
        console.error('Error fetching/storing IP address:', error)
      }
    }
    fetchIpAndStore()

    const handleAfterUnload = (event: any) => {
      event.preventDefault()
      setIsLoggedIn(false)
      setLastUrl(window.location.href)

      sessionStorage.setItem('urlAtLeaving', window.location.href)
      deleteUniqueString(uniqueString)
    }

    const handleBeforeUnload = (event: any) => {
      // event.preventDefault()
      // console.log('handleBeforeunload', window.location.href)
      // setLastUrl(window.location.href)
      // deleteUniqueString(uniqueString)
      // Custom logic to handle the refresh
      // Display a confirmation message or perform necessary actions
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    window.addEventListener('afterUnload', handleAfterUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      window.removeEventListener('afterUnload', handleAfterUnload)
    }
  }, [])

  useEffect(() => {
    if (lastUrl && lastUrl !== window.location.href) {
      if (window.location.href.includes(lastUrl)) {
        // Remove lastUrl from window.location.href
        const newString = window.location.href.replace(lastUrl, '')
        navigate(newString, { replace: true })

        sessionStorage.removeItem('urlAtLeaving')
      }
    }
  }, [lastUrl])

  useEffect(() => {
    if (window.location.href.includes('auth/login') && isLoggedIn) {
      navigate('/NewChat', { replace: true })
    }
  }, [window.location.href])

  // useEffect(() => {

  //   console.log('storedUrlAtLeaving', storedUrlAtLeaving)
  //   console.log('window.location.href', window.location.href)
  //   if (storedUrlAtLeaving) {
  //     navigate(storedUrlAtLeaving)

  //   }
  // }, [window.location.href])

  if (token === undefined) {
    // console.log('src/Layout/HomeLayout.tsx')
    // navigate('/ ')
    setSnackbarMessage('Your session has expired, please login again')
    setSnackbarSeverity('info')
    setSnackbarOpen(true)
    navigate('/', { replace: true })
  }

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false)
  }

  return (
    <Box position='relative'>
      <Header />
      <div>
        <Outlet />
      </div>

      <Footer />
      {snackbarOpen && (
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            elevation={6}
            variant='filled'
            onClose={handleCloseSnackbar}
            severity={snackbarSeverity}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      )}
    </Box>
  )
}

export default HomeLayout
